import { PreState, LegalConsent } from '../organisms/LegalConsents/LegalConsents.types';
import { isStrictEmpty } from './consents';
import { CONSENT_PRESTATE_STORAGE_KEY } from './constants';

export function getStoredPreState(): PreState {
  try {
    const value = localStorage.getItem(CONSENT_PRESTATE_STORAGE_KEY);

    return value ? JSON.parse(value) : {};
  } catch (error) {
    console.error('Failed to load pre-state', error);
    return {};
  }
}

export function saveStoredPreState(preState: PreState): void {
  try {
    localStorage.setItem(CONSENT_PRESTATE_STORAGE_KEY, JSON.stringify(preState));
  } catch (error) {
    console.error('Failed to save pre-state', error);
  }
}

export function clearStoredPreState(): void {
  try {
    localStorage.removeItem(CONSENT_PRESTATE_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear pre-state', error);
  }
}

export function buildPreStateFromConsents(consentList: LegalConsent[]): PreState {
  const preState: PreState = {};
  for (const consent of consentList) {
    for (const checkbox of consent.checkboxes) {
      const { category, id, checked } = checkbox;

      if (isStrictEmpty(category) || isStrictEmpty(id)) {
        continue;
      }

      preState[category] ??= {};

      // preserve true if any checkbox with same category/id is checked
      preState[category][id] = Boolean(preState[category][id]) || Boolean(checked);
    }
  }

  return preState;
}
